<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  beforeDestroy() {
    localStorage.clear();
  }
};
</script>

<style lang="less">
html {
  height: 100%;
}
body {
  height: 100%;
  background-color: #f9f9f9;
}
* {
  margin: 0;
  padding: 0;
}
#app {
  height: 100%;
}
</style>
